"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UpdateBookingItemPayload {
    constructor(id, data) {
        this.id = id;
        this.data = data;
    }
    get model() {
        return {
            data: {
                type: 'booking',
                attributes: {
                    booking_items_attributes: {
                        id: this.data.booking_item_id,
                        deposit_cents: this.data.deposit_cents,
                        price_cents: this.data.price_cents,
                        quantity: this.data.quantity,
                        vat_percentage: this.data.vat_percentage,
                    },
                },
            },
        };
    }
}
exports.default = UpdateBookingItemPayload;
//# sourceMappingURL=BookingItemPricePayload.js.map